var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedMouseRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.5C5.06667 20.5 3.41667 19.8167 2.05 18.45C0.683333 17.0833 0 15.4333 0 13.5V7.5C0 5.56667 0.683333 3.91667 2.05 2.55C3.41667 1.18333 5.06667 0.5 7 0.5C8.93333 0.5 10.5833 1.18333 11.95 2.55C13.3167 3.91667 14 5.56667 14 7.5V13.5C14 15.4333 13.3167 17.0833 11.95 18.45C10.5833 19.8167 8.93333 20.5 7 20.5ZM2 7.5H6V2.6C4.85 2.83333 3.89583 3.40833 3.1375 4.325C2.37917 5.24167 2 6.3 2 7.5ZM7 18.5C8.38333 18.5 9.5625 18.0125 10.5375 17.0375C11.5125 16.0625 12 14.8833 12 13.5V9.5H2V13.5C2 14.8833 2.4875 16.0625 3.4625 17.0375C4.4375 18.0125 5.61667 18.5 7 18.5Z",
    fill: "#0D0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedMouseRightIcon);
export default __webpack_public_path__ + "static/media/DeprecatedMouseRightIcon.41a026bac1eedd8a1d3dca32e11ee64e.svg";
export { ForwardRef as ReactComponent };